import { ViewerOpenContextKind, type ContentViewerSession } from '@/content-viewer/store/schemas'
import { useDraftSourceFootnoteNumber } from './useDraftSourceFootnoteNumber'

/** The name the chat panel shows for its open source: the source's title, prefixed with the draft's footnote number when it has one. */
export function useChatPanelSourceLabel(props: { conversationId: string; sourceSession: ContentViewerSession }): { title: string; label: string } {
  const { conversationId, sourceSession } = props
  const citationContext = sourceSession.context.kind === ViewerOpenContextKind.CHAT_CITATION ? sourceSession.context : null
  // Use the footnote number from the draft's citation, even when it was opened from the chat. The chat's footnote numbers are
  // hidden behind the source while it is being displayed; the draft's are the ones still visible beside it.
  const footnoteNumber = useDraftSourceFootnoteNumber({
    conversationId: citationContext?.conversationId ?? conversationId,
    citationId: citationContext?.citationId,
  })

  // Every kind the panel opens carries a title; one the draft does not number (a file pill, or a source it
  // cites only by name) has no footnote number to prefix.
  const title = 'title' in sourceSession.document ? sourceSession.document.title : ''
  const label = footnoteNumber === null ? title : `[${footnoteNumber}] ${title}`

  return { title, label }
}
